/**
 * ConsentLabel — shared label text for terms/privacy consent checkboxes.
 *
 * Links open in a new tab so an in-progress form (registration, join) is not lost.
 */

import { useTranslation } from "react-i18next"

export function ConsentLabel() {
  const { t } = useTranslation()

  return (
    <span>
      {t("consent.prefix")}{" "}
      <a
        href="/regulamin"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
        // Inside a <label>, a click would toggle the checkbox as a side effect.
        onClick={(e) => e.stopPropagation()}
      >
        {t("consent.termsLink")}
      </a>{" "}
      {t("consent.and")}{" "}
      <a
        href="/polityka-prywatnosci"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
        onClick={(e) => e.stopPropagation()}
      >
        {t("consent.privacyLink")}
      </a>
    </span>
  )
}
